import { BlockedTenantRecordDTO } from '@reposit/api-client';
import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import IdentifierValue from '../../components/IdentifierValue';
import { P2 } from '../../components/Typography';
import { buildBlockedTenantBannerRows } from './blocked-tenant-banner-rows';

const POPPINS_FONT = '"Poppins", sans-serif';

const Banner = styled.div`
  margin: 0 0 20px;
  padding: 20px;
  border-radius: 8px;
  font-family: ${POPPINS_FONT};
  background-color: rgba(232, 49, 81, 0.08);
  border: 1px solid ${(props) => props.theme.colors.negative};
`;

const Title = styled(P2)`
  margin: 0 0 12px;
  font-weight: 600;
  line-height: 1.5;
  font-family: ${POPPINS_FONT};
  color: ${(props) => props.theme.colors.negative};
`;

const Row = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 6px;
  font-size: 14px;
  line-height: 1.5;

  &:last-child {
    margin-bottom: 0;
  }
`;

const Label = styled.span`
  flex: 0 0 110px;
  color: ${(props) => props.theme.colors.body2};
  font-weight: 500;
`;

const Value = styled.span`
  flex: 1;
  color: ${(props) => props.theme.colors.body};
  white-space: pre-wrap;
  overflow-wrap: anywhere;
`;

interface BlockedTenantBannerProps {
  blockedTenant: BlockedTenantRecordDTO;
}

export const BlockedTenantBanner: React.FC<BlockedTenantBannerProps> = ({ blockedTenant }) => (
  <Banner role="status">
    <Title>This tenant is blocked from being added to new Reposits</Title>
    {buildBlockedTenantBannerRows(blockedTenant).map((row) => (
      <Row key={row.label}>
        <Label>{row.label}</Label>
        <Value>
          {row.userId ? (
            <NavLink to={`/users/${row.userId}`}>
              User #<IdentifierValue>{row.userId}</IdentifierValue>
            </NavLink>
          ) : (
            row.value
          )}
        </Value>
      </Row>
    ))}
  </Banner>
);
